module.exports = __webpack_public_path__ + "static/WEDDING E&M-198-8c458969036e3c3105cc46ad2b428fb8.jpg";